// PostalCodeListModel
class PostalCodeListModel {
    constructor({status = null, timestamp = null, area = []} = {}) {
        this.status = status;
        this.timestamp = timestamp;
        this.area = area.map((item) => Area.fromJson(item));
    }

    // Method to convert JSON to PostalCodeListModel instance
    static fromJson(json) {
        return new PostalCodeListModel({
            status: json.status,
            timestamp: json.timestamp,
            area: json.area,
        });
    }

    // Method to convert PostalCodeListModel instance to JSON
    toJson() {
        return {
            status: this.status,
            timestamp: this.timestamp,
            area: this.area.map((item) => item.toJson()),
        };
    }
}

// Area Model
class Area {
    constructor({id = null, city = null, postal_code = null} = {}) {
        this.id = id;
        this.city = city;
        this.postalCode = postal_code;
    }

    // Method to convert JSON to Area instance
    static fromJson(json) {
        return new Area({
            id: json.id,
            city: json.city,
            postal_code: json.postal_code,
        });
    }

    // Method to convert Area instance to JSON
    toJson() {
        return {
            id: this.id,
            city: this.city,
            postal_code: this.postalCode,
        };
    }
}

export default PostalCodeListModel;
